// extracted by mini-css-extract-plugin
export default {"container":"MEOIezL","link":"qprL2SD","image":"XZLBC26","label":"RN3BE_9 XKvcAqM london4","label__sale":"RkwXiO4"};